import { TextsetContextProvider } from '@/contexts/TextSetContext/entry';
import { SetsSelectedWrapper } from './SetsSelectedWrapper';

export default function TextSet(props) {
  return (
    <TextsetContextProvider
      setId={props.route?.params?.setId}
      patientId={props.route?.params?.selectedID}
      apiName={props.route?.params?.apiName}
    >
      <SetsSelectedWrapper props={props} />
    </TextsetContextProvider>
  );
}
